var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuegoGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9224 39.5V79C56.5826 79 74.0002 61.3943 74.0002 39.5V0C52.3399 0 34.9224 17.6057 34.9224 39.5Z",
    fill: "#004B2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1166 54.6227V78.9999C15.7185 78.9999 5 68.1656 5 54.6227V30.4713C18.1748 30.4713 29.1166 41.3056 29.1166 54.6227Z",
    fill: "#004B2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuegoGreen);
export default __webpack_public_path__ + "static/media/fuego-green.96cde88ec7a1eb4c4afd262a6cddfc3a.svg";
export { ForwardRef as ReactComponent };